import React from 'react';
import { Link } from 'react-router-dom';
import { GoogleLogin } from '../Google/LoginByGG';
import { Helmet } from 'react-helmet-async';
import { loginUser } from '@/api/Admin/Auth';

const LoginCard = () => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [status, setStatus] = React.useState<'idle' | 'loading' | 'error'>('idle');

  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  const onFinish = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    setStatus('loading');
    try {
      await loginUser(email, password);
    }
    catch (error) {
      console.error('Login error:', error);
    }
    finally {
      setStatus('idle');
    }
  };

  return (
    <div className="max-w-[460px] mx-auto bg-white p-9 rounded-2xl border-0 shadow-[0_0.5rem_1rem_rgba(2,2,76,0.05)]">
      <Helmet>
        <title>Login - Admin - BeQs Reward</title>
        <meta name="description" content="Login to access your secure admin dashboard on BeQs Reward." />
      </Helmet>
      <div className="text-center mb-6">
        <img src="/images/logo/logo.png" alt="reward logo" className="mx-auto mb-4 w-20 h-full" />
        <h5 className="mb-1 text-lg font-semibold">Admin Panel Reward</h5>
        <p className="text-sm text-gray-600">Sign in to create your secure admin dashboard.</p>
      </div>
      <form onSubmit={onFinish}>
        <div className="mb-6">
          <label className="block text-sm font-medium !text-text-tertiary mb-1" htmlFor="registerEmail">Email Address</label>
          <input
            value={email} onChange={(e) => setEmail(e.target.value)}
            type="email" className="!mt-2 block w-full rounded-md border border-gray-300 bg-white text-gray-900 p-3" id="registerEmail" placeholder="info@example.com" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium !text-text-tertiary mb-1" htmlFor="registerPassword">Password</label>
          <div className="relative">
            <input
              value={password} onChange={(e) => setPassword(e.target.value)}
              type={
                showPassword ? 'text' : 'password'
              } className="!mt-2 block w-full rounded-md border border-gray-300 bg-white text-gray-900 p-3 pr-10" id="registerPassword" placeholder="********" />
            <button type="button" id="togglePassword" className="absolute right-2 top-1/2 -translate-y-1/2 !text-gray-500 hover:!text-gray-700" aria-pressed="false" aria-label="Show password" title="Show password">
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="flex items-center justify-center w-8 h-8 hover:text-gray-700">
                {showPassword ?
                  (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256"><path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"></path></svg>
                  ) :
                  (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"></path></svg>
                  )
                }
              </button>
            </button>
          </div>
        </div>
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center !space-x-2">
            <input className="h-4 w-4 text-primary !no-underline border-gray-300 !rounded" type="checkbox" id="RememberMe" name="remem" />
            <label className="text-sm text-gray-700" htmlFor="RememberMe">
              Remember me
            </label>
          </div>
          <Link to="/forget-password" className="text-sm text-primary-gold !no-underline">Forgot Password?</Link>
        </div>
        <div className="mb-3">
          <button
            title="Sign In"
            type="submit"
            disabled={status === 'loading' || !email || !password}
            className="w-full bg-primary-gold hover:bg-primary-gold/90 !text-white disabled:opacity-50 disabled:!cursor-not-allowed font-semibold py-3 px-4 rounded">
            {status === 'loading' ? 'Signing In...' : 'Sign In'}
          </button>
        </div>
      </form>
      <div>
        {/* <p className="mb-1 text-center text-sm text-text-tertiary">Don't have an account?
          <Link to="/sign-up" className="ml-1 text-sm text-primary !no-underline">Sign Up Here</Link>
        </p> */}
        <div className="relative my-6 text-center">
          <div className="border-t border-gray-200"></div>
          <span
            className="px-3 absolute mt-1 inline-block text-sm text-text-tertiary bg-white"
            style={{ left: '50%', top: '-0.8rem', transform: 'translateX(-50%)' }}
          >
            Or Continue With
          </span>
        </div>
        <GoogleLogin />
      </div>
    </div>
  );
};

export default LoginCard;
